import React, { useRef, useEffect, useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { CATEGORIES } from '../lib/utils';

const CategoryFilter = ({ selectedCategory, onSelectCategory }) => {
  const { t } = useLanguage();
  const scrollRef = useRef(null);

  return (
    <div className="relative w-full border-b border-gray-100">
      <div className="max-w-7xl mx-auto">
        <div 
          ref={scrollRef}
          className="category-scroll flex gap-1.5 md:gap-1 pl-4 md:pl-6 pr-0 md:pr-6 pt-2 pb-[18px] overflow-x-auto overflow-y-visible"
        >
        {/* All categories pill */}
        <button
          onClick={() => onSelectCategory(null)}
          className={`flex items-center justify-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium whitespace-nowrap transition-all flex-shrink-0 md:flex-shrink md:flex-1 outline-none focus:outline-none focus:ring-0 ${
            !selectedCategory 
              ? 'bg-primary text-white' 
              : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
          }`}
          data-testid="category-all"
        >
          <svg viewBox="0 0 24 24" className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="3" width="7" height="7" rx="1" />
            <rect x="14" y="3" width="7" height="7" rx="1" />
            <rect x="3" y="14" width="7" height="7" rx="1" />
            <rect x="14" y="14" width="7" height="7" rx="1" />
          </svg>
          <span>{t('category.all')}</span>
        </button>

        {/* Category pills */}
        {Object.entries(CATEGORIES).map(([key, { icon: Icon, color, bgColor }]) => (
          <button
            key={key}
            onClick={() => onSelectCategory(key)}
            className={`flex items-center justify-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium whitespace-nowrap transition-all flex-shrink-0 md:flex-shrink md:flex-1 outline-none focus:outline-none focus:ring-0 ${
              selectedCategory === key 
                ? 'text-white shadow-sm' 
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            }`}
            style={selectedCategory === key ? { backgroundColor: color } : {}}
            data-testid={`category-${key}`}
          >
            <Icon className="w-3.5 h-3.5" />
            <span>{t(`category.${key}`)}</span>
          </button>
        ))}
        {/* Mobile-only right spacer */}
        <div className="flex-shrink-0 w-4 md:hidden" aria-hidden="true" />
      </div>
      </div>
    </div>
  );
};

export default CategoryFilter;
